import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { withFirebase } from "../../Auth/Firebase";
import './../notifications.css'

const service =
  window.location.hostname === "testing.ruedata.com" ||
    window.location.hostname === "localhost"
    ? "dev/"
    : "prod/";

const BillingModal = ({ firebase, t }) => {
  let customer_id = localStorage.getItem("GlobalCustomerId");
  const db = firebase.doFreeTrial();


  const openBillingModal = () => {
    const content = document.getElementById("bm-content")
    content.style.bottom = "0px"
  }

  const closeBillingModal = () => {
    const content = document.getElementById("bm-content")
    content.style.bottom = "-10000px"
  }

  useEffect(() => {
    if (customer_id) {
      const dbRef = db.ref("notifications/billings/" + service + customer_id);
      dbRef.on("value", (snapshot) => {
        if (snapshot.val()) {
          openBillingModal()
        }
      });
    }
  }, []);

  return (
    <div id="bm-content" className="bm-content">
      <div id="bm-close" className="bm-close" onClick={() => closeBillingModal()}><i class="fas fa-times"></i></div>
      <img className="banner" src="https://jira-emails.s3.amazonaws.com/billing-header.jpg" />
      <h5>Si tienes alguna duda o inconveniente con el pago de tu factura, puedes comunicarte con:</h5>
      <p>
        <img className="country-email" src="https://jira-emails.s3.amazonaws.com/emojione_flag-for-colombia.svg" alt="Colombia" />
        <span>Email:</span> contabilidad@ruedata.com
      </p>
      <p className="phone-number">
        <span>Telefono:</span> +57 316 409 4503
      </p>
      <p>
        <img className="country-email" src="https://jira-emails.s3.amazonaws.com/emojione_flag-for-mexico.svg" alt="Mexico" />
        <span>Email:</span> i.urbiola@ruedata.com
      </p>
      <p className="phone-number">
        <span>Telefono:</span> +52 1 56 3615 2101
      </p>
      <p>
        <img className="country-email" src="https://jira-emails.s3.amazonaws.com/emojione_flag-for-brazil.svg" alt="Brazil" />
        <span>Email:</span> contabilidad@ruedata.com
      </p>
      <p className="phone-number">
        <span>Telefono:</span> +57 316 409 4503
      </p>
    </div>
  );
};

export default withFirebase(BillingModal)